import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Button } from "components/UI";
import { MutationError } from "components/UI/MutationError";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const StructureTypeFormDialog = memo(
  ({
    open,
    editingStructureType,
    formData,
    parentTypeOptions,
    onClose,
    onFormChange,
    onSubmit,
    isLoading,
    error
  }) => {
    const isEditing = Boolean(editingStructureType);

    const { t } = useTranslation();

    const title = isEditing
      ? t("denominations.structures.editStructureType")
      : t("denominations.structures.createStructureType");
    const submitText = isEditing
      ? t("denominations.structures.update")
      : t("denominations.structures.create");

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1 }}>
            <Stack>
              <Typography variant="body2" color="text.secondary">
                {t("denominations.structures.name")}
              </Typography>
              <TextField
                value={formData.name}
                onChange={e => onFormChange("name", e.target.value)}
                fullWidth
                required
              />
            </Stack>

            <Stack>
              <Typography variant="body2" color="text.secondary">
                {t("denominations.structures.description")}
              </Typography>
              <TextField
                value={formData.remark}
                onChange={e => onFormChange("remark", e.target.value)}
                fullWidth
                required
              />
            </Stack>

            <Stack>
              <Typography variant="body2" color="text.secondary">
                {t("denominations.structures.parentType")}
              </Typography>
              <Select
                value={formData.parent_id}
                onChange={e => onFormChange("parent_id", e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  {t("denominations.structures.none")}
                </MenuItem>
                {parentTypeOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Stack>

            <MutationError error={error} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button flavor="outlined" onClick={onClose}>
            {t("denominations.structures.cancel")}
          </Button>
          <Button
            onClick={onSubmit}
            disabled={!formData.name.trim() || isLoading}
            loading={isLoading}
          >
            {submitText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

StructureTypeFormDialog.displayName = "StructureTypeFormDialog";

export default StructureTypeFormDialog;
